/**
 * Dropdown hover
 */
export async function drowpdowHoverInit() {
    const hoverableDropdowns = document.querySelectorAll('.js-dropdown-hover');
    let D = null
    if (hoverableDropdowns.length) {
        const {default: Dropdown} = await import('bootstrap/js/dist/dropdown');
        D = Dropdown
    }
    hoverableDropdowns.forEach(dropdownEl => {
        if (!Array.from(dropdownEl.classList).includes('js-only-cart')) {
            let toggle = dropdownEl.querySelector('.dropdown-toggle');
            if (toggle) {
                let dropdown = new D(toggle);
                let mouseLeaveTimeout;
                dropdownEl.addEventListener('mouseenter', function () {
                    clearTimeout(mouseLeaveTimeout);
                    hoverableDropdowns.forEach(otherEl => {
                        if (otherEl !== dropdownEl) {
                            let otherToggle = otherEl.querySelector('.dropdown-toggle');
                            if (otherToggle) {
                                let otherDropdown = new D(otherToggle);
        
                                otherDropdown.hide();
                            }
                            
                        }
                    });
        
                    dropdown?.show();
                });
                dropdownEl.addEventListener('mouseleave', function () {
                    mouseLeaveTimeout = setTimeout(function () {
                        if (!dropdownEl.matches(':hover')) {
                            dropdown?.hide();
                        }
                    }, 2000);
                });
            }
        }
    });
}
